"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRectangleTransformParameterSettings = exports.validateDraggingParameterSettings = exports.validateGumballTransformParameterSettings = exports.validateSelectionParameterSettings = exports.validateInteractionParameterSettings = exports.IInteractionParameterJsonSchema = exports.IDraggingParameterJsonSchema = exports.IDraggingParameterPropsJsonSchema = exports.IRectangleTransformParameterJsonSchema = exports.IRectangleTransformParameterPropsJsonSchema = exports.IGumballTransformParameterJsonSchema = exports.IGumballTransformParameterPropsJsonSchema = exports.IRestrictionsJsonSchema = exports.IDraggableObjectsJsonSchema = exports.ISelectionParameterJsonSchema = exports.ISelectionParameterPropsJsonSchema = void 0;
const zod_1 = require("../../zod");
const IDrawingParametersSettings_1 = require("./IDrawingParametersSettings");
// #endregion Interfaces (2)
// #region Variables (7)
const optionalBoolean = zod_1.z.preprocess((val) => {
    if (val === "true")
        return true;
    if (val === "false")
        return false;
    if (val === null)
        return undefined;
    return val;
}, zod_1.z.boolean().optional());
const pulseEffectSchema = zod_1.z.object({
    type: zod_1.z.literal("pulse"),
    color: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.number())]).optional(),
    intensity: zod_1.z.number().min(0).optional(),
    pulseSpeed: zod_1.z.number().positive().optional(),
});
const interactionEffectSchema = zod_1.z
    .union([zod_1.z.string(), pulseEffectSchema, zod_1.z.object({}).passthrough()])
    .nullable();
const IGeneralInteractionParameterJsonSchema = zod_1.z.object({
    hover: optionalBoolean,
    hoverColor: interactionEffectSchema.optional(),
    prompt: zod_1.z
        .object({
        inactiveTitle: zod_1.z.string().nullable().optional(),
        activeTitle: zod_1.z.string().nullable().optional(),
        activeText: zod_1.z.string().nullable().optional(),
    })
        .nullable()
        .optional(),
    buttons: zod_1.z
        .object({
        clear: optionalBoolean,
    })
        .nullable()
        .optional(),
    activeMode: zod_1.z.enum(["default", "activeOnStart", "alwaysActive"]).optional(),
    occludeBySceneGeometry: optionalBoolean,
    presentation: zod_1.z.enum(["widget", "toolbar"]).optional(),
    autoClear: optionalBoolean,
});
exports.ISelectionParameterPropsJsonSchema = zod_1.z
    .object({
    maximumSelection: zod_1.z.number().nullable().optional(),
    minimumSelection: zod_1.z.number().nullable().optional(),
    nameFilter: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    selectionColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    deselectOnEmpty: optionalBoolean,
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.ISelectionParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("selection"),
    props: exports.ISelectionParameterPropsJsonSchema,
});
exports.IDraggableObjectsJsonSchema = zod_1.z
    .array(zod_1.z.object({
    nameFilter: zod_1.z.string(),
    restrictions: zod_1.z.array(zod_1.z.string()),
    dragAnchors: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        position: zod_1.z.array(zod_1.z.number()),
        rotation: zod_1.z
            .object({
            axis: zod_1.z.array(zod_1.z.number()),
            angle: zod_1.z.number(),
        })
            .nullable()
            .optional(),
    }))
        .nullable()
        .optional(),
    dragOrigin: zod_1.z.array(zod_1.z.number()).nullable().optional(),
}))
    .nullable()
    .optional();
exports.IRestrictionsJsonSchema = zod_1.z
    .array(zod_1.z
    .object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    rotation: zod_1.z
        .object({
        axis: zod_1.z.array(zod_1.z.number()),
        angle: zod_1.z.number(),
    })
        .nullable()
        .optional(),
})
    .passthrough())
    .nullable()
    .optional();
exports.IGumballTransformParameterPropsJsonSchema = zod_1.z
    .object({
    enableRotation: optionalBoolean,
    enableRotationAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    enableScaling: optionalBoolean,
    enableScalingAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    enableTranslation: optionalBoolean,
    enableTranslationAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    nameFilter: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    scale: zod_1.z.number().nullable().optional(),
    space: zod_1.z.literal("local").or(zod_1.z.literal("world")).nullable().optional(),
    selectionColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    maximumSelection: zod_1.z.number().nullable().optional(),
    minimumSelection: zod_1.z.number().nullable().optional(),
    deselectOnEmpty: optionalBoolean,
    objects: exports.IDraggableObjectsJsonSchema,
    restrictions: exports.IRestrictionsJsonSchema,
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.IGumballTransformParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("gumball"),
    props: exports.IGumballTransformParameterPropsJsonSchema,
});
exports.IRectangleTransformParameterPropsJsonSchema = zod_1.z
    .object({
    enableRotation: optionalBoolean,
    enableScaling: optionalBoolean,
    enableTranslation: optionalBoolean,
    nameFilter: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    selectionColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    maximumSelection: zod_1.z.number().nullable().optional(),
    minimumSelection: zod_1.z.number().nullable().optional(),
    deselectOnEmpty: optionalBoolean,
    objects: exports.IDraggableObjectsJsonSchema,
    restrictions: exports.IRestrictionsJsonSchema,
    plane: zod_1.z
        .object({
        id: zod_1.z.string().optional(),
        type: zod_1.z.string(),
        origin: zod_1.z.array(zod_1.z.number()).optional(),
        vector_u: zod_1.z.array(zod_1.z.number()),
        vector_v: zod_1.z.array(zod_1.z.number()),
        rotation: zod_1.z
            .object({
            axis: zod_1.z.array(zod_1.z.number()),
            angle: zod_1.z.number(),
        })
            .nullable()
            .optional(),
    })
        .passthrough()
        .nullable()
        .optional(),
    corners: zod_1.z
        .object({
        topLeft: optionalBoolean,
        topRight: optionalBoolean,
        bottomLeft: optionalBoolean,
        bottomRight: optionalBoolean,
    })
        .nullable()
        .optional(),
    edgeControls: zod_1.z
        .object({
        top: optionalBoolean,
        bottom: optionalBoolean,
        left: optionalBoolean,
        right: optionalBoolean,
    })
        .nullable()
        .optional(),
    scaling: zod_1.z
        .object({
        uniform: optionalBoolean,
        uMin: zod_1.z.number().nullable().optional(),
        uMax: zod_1.z.number().nullable().optional(),
        vMin: zod_1.z.number().nullable().optional(),
        vMax: zod_1.z.number().nullable().optional(),
        step: zod_1.z.number().nullable().optional(),
        visualization: IDrawingParametersSettings_1.IDrawingParameterVisualizationSettingsJsonSchema,
    })
        .nullable()
        .optional(),
    rotation: zod_1.z
        .object({
        step: zod_1.z.number().nullable().optional(),
        stepThreshold: zod_1.z.number().nullable().optional(),
        min: zod_1.z.number().nullable().optional(),
        max: zod_1.z.number().nullable().optional(),
        handleDistance: zod_1.z.number().nullable().optional(),
        visualization: IDrawingParametersSettings_1.IDrawingParameterVisualizationSettingsJsonSchema,
    })
        .nullable()
        .optional(),
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.IRectangleTransformParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("rectangleTransform"),
    props: exports.IRectangleTransformParameterPropsJsonSchema,
});
exports.IDraggingParameterPropsJsonSchema = zod_1.z
    .object({
    draggingColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    objects: exports.IDraggableObjectsJsonSchema,
    restrictions: exports.IRestrictionsJsonSchema,
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.IDraggingParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("dragging"),
    props: exports.IDraggingParameterPropsJsonSchema,
});
exports.IInteractionParameterJsonSchema = exports.ISelectionParameterJsonSchema.or(exports.IGumballTransformParameterJsonSchema)
    .or(exports.IRectangleTransformParameterJsonSchema)
    .or(exports.IDraggingParameterJsonSchema);
const validateInteractionParameterSettings = (param) => {
    return exports.IInteractionParameterJsonSchema.safeParse(param);
};
exports.validateInteractionParameterSettings = validateInteractionParameterSettings;
const validateSelectionParameterSettings = (param) => {
    return exports.ISelectionParameterJsonSchema.safeParse(param);
};
exports.validateSelectionParameterSettings = validateSelectionParameterSettings;
const validateGumballTransformParameterSettings = (param) => {
    return exports.IGumballTransformParameterJsonSchema.safeParse(param);
};
exports.validateGumballTransformParameterSettings = validateGumballTransformParameterSettings;
const validateDraggingParameterSettings = (param) => {
    return exports.IDraggingParameterJsonSchema.safeParse(param);
};
exports.validateDraggingParameterSettings = validateDraggingParameterSettings;
const validateRectangleTransformParameterSettings = (param) => {
    return exports.IRectangleTransformParameterJsonSchema.safeParse(param);
};
exports.validateRectangleTransformParameterSettings = validateRectangleTransformParameterSettings;
// #endregion Variables (7)
//# sourceMappingURL=IInteractionParameterSettings.js.map